import { render, staticRenderFns } from "./ErrorFallback.vue?vue&type=template&id=3ffa50ee&scoped=true"
import script from "./ErrorFallback.vue?vue&type=script&lang=js"
export * from "./ErrorFallback.vue?vue&type=script&lang=js"
import style0 from "./ErrorFallback.vue?vue&type=style&index=0&id=3ffa50ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffa50ee",
  null
  
)

export default component.exports